module.exports = __webpack_public_path__ + "static/img/1b.f1dab60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1b.png
// module id = MNND
// module chunks = 1